import React from "react";
import {ColumnProps} from "antd/es/table";
import {FIELD_TYPE} from "types/enums";
const {INPUT, TEXT_AREA} = FIELD_TYPE;
const TEL_NUMBER_REGEX = /^[0-9-]*$/;

const columns: ColumnProps<any>[] = [
  {
    key: "1",
    title: "STT",
    dataIndex: "",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    width: 80,
    align: "center",
  },
  {
    key: "2",
    title: "Mã NCC",
    dataIndex: "id",
    width: 100,
  },
  {
    key: "name",
    title: "Tên NCC",
    dataIndex: "name",
    width: 250,
  },
  {
    key: "address",
    title: "Địa chỉ",
    dataIndex: "address",
    width: 250,
  },
  {
    key: "representative",
    title: "Người phụ trách",
    dataIndex: "representative",
    width: 200,
  },
  {
    key: "phone",
    title: "Số điện thoại",
    dataIndex: "phone",
    width: 150,
    align: "right"
  },
  {
    key: "email",
    title: "Email",
    dataIndex: "email",
    width: 150,
  },
  {
    key: "description",
    title: "Ghi chú",
    dataIndex: "description",
    width: 350,
  },
  {
    key: "action",
    title: "",
    dataIndex: "action",
    width: 150,
    fixed: "right",
  },
];
const dataFields: any[] = [
  {
    type: INPUT,
    label: "Mã NCC",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tên NCC",
    name: "name",
    rules: [{required: true, message: "Chưa nhập Tên NCC"}],
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "address",
    rules: [{required: true, message: "Chưa nhập Địa chỉ"}],
  },
  {
    type: INPUT,
    label: "Người phụ trách",
    name: "representative",
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "phone",
    rules: [
      {
        pattern: new RegExp(TEL_NUMBER_REGEX),
        message: "Số điện thoại không đúng định dạng",
      },
    ],
  },
  {
    type: INPUT,
    label: "Email",
    name: "email",
    rules: [{type: "email", message: "Email không đúng định dạng"}],
  },
  {
    type: TEXT_AREA,
    label: "Ghi chú",
    name: "description",
  },
];
export {columns, dataFields};
